var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCabinets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.25 12V6C16.2497 5.73696 16.1803 5.47861 16.0487 5.25087C15.917 5.02314 15.7278 4.83402 15.5 4.7025L10.25 1.7025C10.022 1.57085 9.7633 1.50154 9.5 1.50154C9.2367 1.50154 8.97803 1.57085 8.75 1.7025L3.5 4.7025C3.2722 4.83402 3.08299 5.02314 2.95135 5.25087C2.81971 5.47861 2.75027 5.73696 2.75 6V12C2.75027 12.263 2.81971 12.5214 2.95135 12.7491C3.08299 12.9769 3.2722 13.166 3.5 13.2975L8.75 16.2975C8.97803 16.4292 9.2367 16.4985 9.5 16.4985C9.7633 16.4985 10.022 16.4292 10.25 16.2975L15.5 13.2975C15.7278 13.166 15.917 12.9769 16.0487 12.7491C16.1803 12.5214 16.2497 12.263 16.25 12Z",
    stroke: "#121212",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.95215 5.22L9.49965 9.0075L16.0471 5.22",
    stroke: "#121212",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.5 16.56V9",
    stroke: "#121212",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCabinets);
export default __webpack_public_path__ + "static/media/cabinets.813e7293d1aceb8e0dd37bf0b7dc0292.svg";
export { ForwardRef as ReactComponent };